<template>
  <div class="event-log-panel py-4">
    <div class="title-bar px-6">
      <span class="title">Event Log</span>
      <div class="flex flex-row gap-1">
        <SmartSelect
          v-model="queryParameters.level"
          :options="enumToOptions(EventLogLevel)"
          class="select-width"
          placeholder="Level"
          size="small"
          valueType="number"
          valueField="id"
          clearable
        />
        <SmartSelect
          v-model="queryParameters.status"
          :options="enumToOptions(EventLogStatus)"
          class="select-width"
          placeholder="Status"
          size="small"
          valueType="number"
          valueField="id"
          clearable
        />
      </div>
    </div>
    <div class="h-4"></div>
    <div class="relative flex-1">
      <el-scrollbar class="scroll-bar absolute inset-0">
        <div
          class="flex flex-col gap-4 px-6"
          v-infinite-scroll="loadMoreEvents"
          :infinite-scroll-disabled="infiniteScrollDisabled"
          :infinite-scroll-distance="200"
        >
          <template v-if="eventLogList.state.list.length">
            <EventLogItem
              v-for="item of eventLogList.state.list"
              :key="item.id"
              :item="item"
              @update="handleUpdateItem(item,$event)"
            />
            <div
              v-if="eventLogList.state.loading"
              class="text-center text-gray-400 py-2"
            >
              Loading...
            </div>
            <div
              v-if="eventLogList.state.noMore"
              class="text-center text-gray-400 py-2"
            >
              No more
            </div>
          </template>
          <template v-else>
            <div
              class="absolute inset-0 flex justify-center items-center py-12 text-gray-400 text-base"
            >
              No data
            </div>
          </template>
        </div>
      </el-scrollbar>
    </div>
    <div class="flex flex-row justify-end px-4">
      <el-tooltip content="View all event logs" placement="top">
        <el-button @click="handleViewAll" icon="el-icon-s-order">
          View All
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import SmartSelect from "@/components/SmartControls/SmartSelect.vue";
import { EventLogStatus, EventLogLevel, enumToOptions } from "@/enums";
import EventLogItem from "./EventLogItem.vue";
import { EventBus } from "@/event-bus";
import { getEvents } from "@/api";
import { InfiniteScrollController } from "@/controllers/InfiniteScrollController";
const PAGE_SIZE = 10;

export default {
  name: "EventLogPanel",
  components: {
    SmartSelect,
    EventLogItem,
  },
  data() {
    return {
      EventLogStatus,
      EventLogLevel,
      queryParameters: {
        level: undefined,
        status: undefined,
      },
      eventLogList: new InfiniteScrollController({
        loadMethod: getEvents,
        pageSize: PAGE_SIZE,
        keyField: "id",
        pageField: "offset",
        pageSizeField: "limit",
        queryParameters: {
          level: null,
          status: null,
        },
      }),
    };
  },
  watch: {
    queryParameters: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
  computed: {
    infiniteScrollDisabled() {
      return this.eventLogList.state.loading || this.eventLogList.state.noMore;
    },
  },
  methods: {
    async loadMoreEvents() {
      await this.eventLogList.loadMore();
    },
    enumToOptions,
    async refresh(globalDispatch = true) {
      await this.eventLogList.reload({
        level: this.queryParameters.level,
        status: this.queryParameters.status,
      });
      if (globalDispatch) {
        EventBus.$emit("event-log-refreshed");
      }
    },
    handleViewAll() {
      this.$router.push({ name: "ai-audit-logs" });
    },
    handleUpdateItem(oldItem, newItem) {
      Object.assign(oldItem, newItem);
    },
  },
  mounted() {
    this.refresh(false);
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.event-log-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #1e2328;
  border-radius: 10px;
  color: white;
}

.title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-bar .title {
  font-size: 20px;
  font-weight: bold;
  color: white;
}

.select-width {
  width: 120px;
}

.scroll-bar {
  flex: 1 1 0;
}

.scroll-bar ::v-deep .el-scrollbar__wrap {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
}
</style>
